export const getTitle = (isSubscription: boolean): string => {
  const entityName = isSubscription ? 'подписки' : 'пакета';

  return `Срок действия ${entityName}`;
};
